module.exports = __webpack_public_path__ + "static/media/contacts-icon.fad6fd62.svg";